import { type ReactNode } from 'react';

import { Dialog, DialogContent } from '@/components/ui/dialog';
import { InviteClientMethod } from '@/components/invite-client/InviteClientMethod';
import { InviteClientLinkInfo } from '@/components/invite-client/InviteClientLinkInfo';
import { InviteClientEmailInfo } from '@/components/invite-client/InviteClientEmailInfo';
import { EmailDeliverabilityWarningModal } from '@/components/EmailDeliverabilityWarningModal';
import { InviteClientCustomizeEmail } from '@/components/invite-client/InviteClientCustomizeEmail';
import { InviteClientAdditionalSettings } from '@/components/invite-client/InviteClientAdditionalSettings';

import {
  InviteClientProvider,
  useInviteClientContext,
  useInviteClientTrigger,
} from '@/components/invite-client/InviteClientContext';

import { v4 as newUuid } from 'uuid';

const STEPS: { [key: string]: ReactNode } = {
  'method': <InviteClientMethod />,
  'email': <InviteClientEmailInfo />,
  'customize-email': <InviteClientCustomizeEmail />,
  'email-additional-settings': <InviteClientAdditionalSettings />,
  'link': <InviteClientLinkInfo />,
  'link-additional-settings': <InviteClientAdditionalSettings mode="link" />,
};

function InviteClientModalContent() {
  const {
    inviteClientConfig,
    showEmailWarningModal,
    setShowEmailWarningModal,
    handleConnectEmail,
    handleSendEmailAnyway,
    generateIntakeFormLink,
    generateEmailText,
  } = useInviteClientContext();
  const { isInviteClientOpen, setInviteClientParams, clearInviteClientParams } =
    useInviteClientTrigger();

  return (
    <>
      <Dialog
        open={isInviteClientOpen}
        onOpenChange={() => {
          if (isInviteClientOpen) {
            clearInviteClientParams();
          } else {
            setInviteClientParams();
          }
        }}
      >
        <DialogContent className="max-h-[90vh] max-w-xl">
          {STEPS[inviteClientConfig.currentStep]}
        </DialogContent>
      </Dialog>

      <EmailDeliverabilityWarningModal
        open={showEmailWarningModal}
        onClose={() => setShowEmailWarningModal(false)}
        onConnectEmail={handleConnectEmail}
        onSendAnyway={handleSendEmailAnyway}
        intakeFormLink={generateIntakeFormLink(newUuid())}
        emailTextContent={generateEmailText()}
      />
    </>
  );
}

export function InviteClientModal() {
  return (
    <InviteClientProvider>
      <InviteClientModalContent />
    </InviteClientProvider>
  );
}
